"use strict";
import angular from 'angular';

let captchaV2 = angular
    .module("captchaV2", ["captchaV2Templates"]);

export default captchaV2;